interface SectionLabelProps {
  label: string;
  className?: string;
}

export default function SectionLabel({ label, className = "" }: SectionLabelProps) {
  return (
    <span
      className={`inline-block text-xs md:text-sm font-medium tracking-[0.15em] uppercase text-primary-500 font-label ${className}`}
    >
      {label}
    </span>
  );
}